<template>
  <div>
    <div>
      <span class="currentDate">第 {{currentWeekInfo.currentWeekOfYear}} 周</span>
    </div>
    <div>
      <span class="currentDate">{{currentWeekInfo.now|currentTimeShow}}</span>
    </div>
  </div>
</template>
<script>
import { dateFtt } from "@/utils/auth.js";
export default {
  name: "currentDate",
  data() {
    return {
        currentWeekInfo:{}
    };
  },
  filters: {
    currentTimeShow: function(value) {
      return dateFtt("yyyy年MM月dd日 EEE ",value);
    }
  },
  mounted(){
   this.getCurrentDate();
  },
  methods:{
    async getCurrentDate() {
      //获取当前日期
      let resData = await this.$dateTimeHelperApi.getDateTime();
      if (resData && resData.data.successful) 
      {
        this.$userContext.setDateTime(resData.data.data);
        this.currentWeekInfo = resData.data.data;
        this.$emit('pageReadyFunc',this.currentWeekInfo)
      } 
      else 
      {
        this.$alert(resData.data.message, "提示");
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/views/common/currentDate.vue